import { render } from "./SchoolManageComponent.vue?vue&type=template&id=1359d0a4&scoped=true"
import script from "./SchoolManageComponent.vue?vue&type=script&lang=js"
export * from "./SchoolManageComponent.vue?vue&type=script&lang=js"

import "./SchoolManageComponent.vue?vue&type=style&index=0&id=1359d0a4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1359d0a4"]])

export default __exports__